module.exports = __webpack_public_path__ + "img/lefan-banner.ac64859b.jpg";